import { memo } from "react";
import { Box, Flex, Text, useMantineTheme } from "@mantine/core";
import { GetSignedAgreementsQuery } from "src/generated/graphql";
import { AiFillEye } from "react-icons/ai";

type IUpcomingPaymentsProps = {
  data?: NonNullable<
    GetSignedAgreementsQuery["signedAgreementMany"]
  >[0]["agreement"]["additionalPolicies"];
  onRefetch: () => void;
  viewPolicy: () => void;
};

const PolicyDocuments = ({
  data,
  onRefetch,
  viewPolicy,
}: IUpcomingPaymentsProps) => {
  const theme = useMantineTheme();

  return (
    <Box m={10}>
      <Flex
        direction={"column"}
        my={5}
        px={5}
        bg={theme.colors.secondary[6]}
        style={{ borderRadius: 10 }}
      >
        {data?.map((policy, index) => {
          return (
            <Flex
              key={policy.name + index}
              w="100%"
              py={5}
              px={5}
              style={{
                alignItems: "center",
                justifyContent: "space-between",
                background: index % 2 !== 0 ? theme.colors.secondary[4] : "",
                borderTop:
                  index % 2 !== 0
                    ? `1px solid ${theme.colors.secondary[2]}`
                    : "",
                borderBottom:
                  index % 2 !== 0
                    ? `1px solid ${theme.colors.secondary[2]}`
                    : "",
              }}
            >
              <Text size={12} fw={400}>
                {`${policy?.name}`}
              </Text>
              <AiFillEye
                onClick={() => viewPolicy()}
                color={theme.colors.secondaryTextColor[6]}
              />
            </Flex>
          );
        })}
      </Flex>
    </Box>
  );
};

export default memo(PolicyDocuments);
